module.exports = __webpack_public_path__ + "img/004.89ae7c67.jpg";